module.exports = '4.11.0';



// WEBPACK FOOTER //
// ./src/version.js